module.exports = __webpack_public_path__ + "static/media/tuberia-conduit-codo-pared-delgada.c3761ae5.jpg";